import React from 'react';

import { Dropdown } from 'semantic';
import { useTranslation } from 'react-i18next';

import InspectObject from 'components/modals/InspectObject';
import { request } from 'utils/api';
import { Invoice } from 'types/invoice';

type Props = {
  item: Invoice;
  onReload: () => void;
};

export default function InvoiceActions({ item, onReload }: Props) {
  const { t } = useTranslation();

  const fetchInvoice = async (id: string) => {
    const { data } = await request({
      method: 'GET',
      path: `/1/invoices/${id}`,
    });

    return data;
  };

  return (
    <>
      <Dropdown.Item
        onClick={() => {
          request({
            path: `/1/invoices/${item.id}/sessions/download`,
            method: 'GET',
            params: {
              filename: `${item.identifier}-sessions.csv`,
            },
          });
        }}
        icon="download"
        text={t(
          'invoices.tableColumn.actions.downloadSessions',
          'Download Sessions'
        )}
      />
      <Dropdown.Item
        onClick={() => {
          request({
            path: `/1/invoices/${item.id}/billable-items/export`,
            method: 'GET',
          });
        }}
        icon="file-csv"
        text={t(
          'invoices.tableColumn.actions.downloadBillableItems',
          'Download Invoice Billable Items'
        )}
      />
      <InspectObject
        name="Invoice"
        trigger={
          <Dropdown.Item text={t('common.inspect', 'Inspect')} icon="code" />
        }
        getData={() => fetchInvoice(item.id)}
      />
    </>
  );
}
